<template>
    <div class="p-inputgroup">
        <AutoComplete v-model="input" :class="inputClass" forceSelection :suggestions="autocompleteResult" @item-select="setResult($event)"
            @complete="searchAddress($event)" optionLabel="tekst" autocomplete="off" :placeholder="'By eller Postnr.'"
            aria-label="Indtast by eller postnummer" />
        <Button :icon="'pi ' + icon" :disabled="result == null" @click="doSearch"></Button>
    </div>

</template>
<script>
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';

export default {
    name: "ZipCitySearch",
    props: ['searchCallback','icon','inputClass','searchImmediately'],
    components: {
        AutoComplete,
        Button

    },
    data() {
        return {
            dictionary: [],
            resultBaseUrl: null,
            autocompleteResult: null,
            input: null,
            result: null
        };
    },
    created() {
        const vm = this;
        vm.resultBaseUrl = vm.$parent.resultUrl;
    },
    methods: {
        doSearch() {
            const vm = this;
            const latitude = vm.result.visueltcenter_y;
            const longitude = vm.result.visueltcenter_x;

            if (typeof vm.searchCallback != 'undefined') {
                vm.searchCallback(latitude,longitude);
            } else {
                window.location.href = `${vm.resultBaseUrl}?location=${latitude},${longitude}`;
            }

            vm.input = null;

        },
        setResult(event) {
            const vm = this;
            vm.result = event.value.postnummer;
            if(vm.searchImmediately) {
                vm.doSearch();
            }
        },
        searchAddress(event) {
            const vm = this;
            fetch('https://api.dataforsyningen.dk/postnumre/autocomplete?q=' + event.query)
                .then(response => response.json())
                .then(data => {
                    vm.autocompleteResult = data;
                })
                .catch(error => {
                    console.log(error);
                })
        },
    }
};
</script>
